import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { atlTheme } from '../../atlTheme'
import { icons } from '../../constants/searchAssets'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { Switch, withStyles } from '@material-ui/core'
import { usePromise } from '../../utils/hooks/usePromise'
import { updateSendNotification } from '../../services/main/updateSendNotification'

const Container = styled.div`
  padding: 0 ${atlTheme.SpacingMarginal}px;
  border-radius: ${atlTheme.BorderRadiusCard}px;
  background: ${atlTheme.ColorSurface};
  min-height: ${atlTheme.SpacingButtonMarginHorizontal}px;
  margin-top: ${atlTheme.SpacingBase}px;
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`

const Icon = styled.img`
  height: ${atlTheme.SpacingDistribute}px;
  width: ${atlTheme.SpacingDistribute}px;
  margin-right: ${atlTheme.SpacingMarginal}px;
  align-self: center;
`

const Label = styled.div`
  font-family: ${atlTheme.FontFamilyBrand};
  color: ${atlTheme.ColorHighContrast};
  font-size: ${atlTheme.FontSizeBody}px;
  display: flex;
  align-items: center;
  width: 100%;
`

const BrandSwitch = withStyles({
  switchBase: {
    color: atlTheme.ColorWhite,
    '&$checked': {
      color: atlTheme.ColorWhite,
    },
    '&$checked + $track': {
      backgroundColor: atlTheme.ColorBrand1Default,
      opacity: '0.8',
    },
  },
  checked: {},
  track: {},
})(Switch)

interface ActivateNotificationsProps {
  isPushEnabled: boolean
}

export const ActivateNotifications: React.FunctionComponent<ActivateNotificationsProps> = ({ isPushEnabled }) => {
  const [isSwitchActive, setIsSwitchActive] = useState<boolean>(isPushEnabled)

  const toggleSwitch = () => {
    setIsSwitchActive(!isSwitchActive)
  }

  const { request: updateNotificationsPreference } = usePromise(updateSendNotification)

  useEffect(() => {
    if (isSwitchActive !== undefined) {
      updateNotificationsPreference({ sendNotifications: isSwitchActive })
    }
  }, [isSwitchActive])

  useEffect(() => {
    setIsSwitchActive(isPushEnabled)
  }, [isPushEnabled])

  return (
    <Container>
      <Icon src={icons.alert} />
      <Label>{formatMessage(messages.profileScreen_activateNotifications)}</Label>
      <BrandSwitch checked={isSwitchActive} onChange={toggleSwitch} value={isSwitchActive} />
    </Container>
  )
}
